import React, { useEffect, useRef, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Button, Container } from "react-bootstrap";
import Nav from "./Navbar";
import Footer from "./Footer";
const Privacy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);


  return (
    <Container fluid className="p-0" style={{ overflowX: "hidden" }}>
      {/* home */}

      <div>
        {/* <div
          className="d-flex justify-content-center"
          style={{ background: "#fdca40" }}
        >
         <p className="p-2 m-0 text-center">
            Start with free trial of <b>SeoBix!</b>-boost your SEO game&nbsp;&nbsp; <Button size="sm" variant="success">Know More</Button>
          </p>
        </div> */}
        <Nav />
      </div>
      {/* start */}
      <div className=" p-0">
        <div className="mt-md-5 mt-3">
          <div className="row  mx-md-0 mx-3  mt-sm-3">
            <div className="col-md-1 "></div>
            <div className="col m-0 p-0">
              <h1
                style={{
                  color: "#090040",
                  justifyContent: "center",
                  display: "flex",
                }}
              >
                Privacy Policy – SeoBix
              </h1>
              <PrivacyPolicy />

              <h2 style={{ marginTop: "1rem", color: "#090040" }}>
                {" "}
                Contact Information
              </h2>
              <p>
                If you have any questions, concerns, or requests regarding this
                Privacy Policy or your personal data, please contact us at:
              </p>
              <p>
                Email:{" "}
                <a href="mailto:support@Seobix.com">support@Seobix.com</a>
                <br />
                Website:{" "}
                <a
                  href="https://Seobix.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://Seobix.com
                </a>
              </p>
            </div>

            <div className="col-md-1"></div>
          </div>
        </div>
      </div>
      {/* end */}
      <div
        className="m-0 p-0"
        style={{
          overflow: "hidden",
          background:
            "linear-gradient(to right, rgb(175, 221, 255), rgb(255, 255, 255))",

          borderTopRightRadius: "2rem",
          borderTopLeftRadius: "2rem",
        }}
      >
        <Footer />
      </div>
    </Container>
  );
};

const PrivacyPolicy = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  const tocItems = [
    "Introduction",
    "Key Definitions",
    "Information We Collect",
    {
      title: "Information Collected Automatically",
      subItems: [
        "Device and Usage Data",
        "Third-Party Widgets",
        "Cookies and Similar Technologies",
      ],
    },
    "Information Provided Directly by You",
    "Information Received From Third Parties",
    "How We Use Your Personal Data",
    "How We Disclose Your Personal Data",
    "Data Retention",
    "How We Protect Your Personal Data",
    "International Transfers of Personal Data",
    "Privacy Rights and Choices",
    "Children",
    "Contact Information",
  ];

  const formatId = (text) =>
    text
      .toLowerCase()
      .replace(/\s+/g, "-")
      .replace(/[^\w-]+/g, "");
  const linkStyle = {
    color: "#1D4ED8",
    cursor: "pointer",
    marginBottom: "0.5rem",
    display: "block",
  };

  const subLinkStyle = {
    ...linkStyle,
    marginLeft: "20px",
    fontSize: "0.95rem",
  };
  return (
    <div className="max-w-5xl mx-auto p-6">
      <p className="text-gray-600 mb-6 text-center">Effective Date: September 29, 2025</p>

      <p className="mb-6">
        At Seobix.com, we value your privacy and are committed to protecting
        your personal information. This Privacy Policy explains how we collect,
        use, and safeguard your data when you use our website and services. By
        using Seobix.com, you consent to the practices described in this policy.
      </p>

      {/* Table of Contents */}
      <h2 className="text-2xl font-semibold mb-4">Table of Contents</h2>
      <ul style={{ listStyle: "none", paddingLeft: "0" }}>
        {tocItems.map((item, index) =>
          typeof item === "string" ? (
            <li
              key={index}
              onClick={() => scrollToSection(formatId(item))}
              style={linkStyle}
              onMouseOver={(e) => (e.target.style.color = "#1E40AF")}
              onMouseOut={(e) => (e.target.style.color = "#1D4ED8")}
            >
              {`${index + 1}. ${item}`}
            </li>
          ) : (
            <li key={index}>
              <span
                onClick={() => scrollToSection(formatId(item.title))}
                style={linkStyle}
                onMouseOver={(e) => (e.target.style.color = "#1E40AF")}
                onMouseOut={(e) => (e.target.style.color = "#1D4ED8")}
              >
                {`${index + 1}. ${item.title}`}
              </span>
              <ul style={{ listStyle: "none", paddingLeft: "20px" }}>
                {item.subItems.map((subItem, subIndex) => (
                  <li
                    key={subIndex}
                    onClick={() => scrollToSection(formatId(subItem))}
                    style={subLinkStyle}
                    onMouseOver={(e) => (e.target.style.color = "#1E40AF")}
                    onMouseOut={(e) => (e.target.style.color = "#1D4ED8")}
                  >
                    {`${index + 1}.${subIndex + 1} ${subItem}`}
                  </li>
                ))}
              </ul>
            </li>
          )
        )}
      </ul>

      {/* Sections */}
      <div className="space-y-8 mt-8 text-justify leading-relaxed">
        <section className="mt-4 mb-4" id={formatId("Introduction")}>
          <h3 className="text-xl font-semibold mb-2">1. INTRODUCTION</h3>
          <p>
            At Seobix.com, your privacy is fundamental to us. We understand that
            in the digital age, your personal information is valuable and should
            be treated with the highest standards of security and transparency.
            This Privacy Policy outlines the types of personal data we collect,
            how we use it, with whom we share it, and the measures we take to
            protect your data. Our goal is to ensure you have a clear
            understanding of how Seobix.com handles your information, so you can
            make informed decisions while using our platform.
          </p>
          <p>
            We encourage all visitors and users of our website to read this
            policy carefully. By using Seobix.com, you acknowledge that you have
            read and understood this Privacy Policy and agree to its terms.
          </p>
        </section>

        <section className="mt-4 mb-4" id={formatId("Key Definitions")}>
          <h3 className="text-xl font-semibold mb-2">2. KEY DEFINITIONS</h3>
          <ul className="list-disc list-inside">
            <li>
              <b>Personal Data:</b> Any information that identifies or can
              reasonably identify an individual, including name, email address,
              IP address, or usage behavior.
            </li>
            <li>
              <b>Processing:</b> Any operation or set of operations performed on
              personal data, including collection, storage, use, sharing, or
              deletion.
            </li>
            <li>
              <b>Third Parties:</b> External organizations or services with whom
              we may share information, such as analytics providers, advertising
              networks, or social media platforms.
            </li>
            <li>
              <b>Cookies and Similar Technologies:</b> Small files stored on
              your device to enhance user experience, track usage, or enable
              third-party services.
            </li>
          </ul>
        </section>

        <section className="mt-4 mb-4" id={formatId("Information We Collect")}>
          <h3 className="text-xl font-semibold mb-2">
            3. INFORMATION WE COLLECT
          </h3>
        </section>

        <section className="mt-4 mb-4" id={formatId("Information Provided Directly by You")}>
          <h4 className="text-lg font-semibold mb-2">
            a) Information Provided Directly by You
          </h4>
          <p>
            When you interact with Seobix.com, we may collect information you
            voluntarily provide. This includes personal details like your name,
            email address, phone number, and business information when you
            reach to fill out contact
            forms. For example, when you sign up for our SEO insights or submit
            a query for SEO consultation, the information you provide enables us
            to respond effectively and tailor our services to your needs.
          </p>
          <p>
            Providing this information is entirely voluntary, but without it,
            certain functionalities such as personalized recommendations,
            customer support, or email updates may be limited. We also collect
            details related to payment, billing, and account information if you
            purchase services through our platform.
          </p>
        </section>

        <section className="mt-4 mb-4" id={formatId("Information Received From Third Parties")}>
          <h4 className="text-lg font-semibold mb-2">
            b) Information Received From Third Parties
          </h4>
          <p>
            We may also receive information about you from third-party sources,
            such as business partners, publicly available databases, or
            analytics providers. For instance, tools like Moz provide
            SEO-related insights that can help us improve our services and
            tailor content to users’ needs. Social media integrations like
            Facebook, Instagram, LinkedIn, Meta, and YouTube may also share
            information based on your interactions with our content on their
            platforms.
          </p>
          <p>
            This information may include demographic details, public profiles,
            or engagement data. It allows Seobix.com to offer a more seamless
            user experience and relevant insights while ensuring compliance with
            privacy regulations.
          </p>
        </section>

        <section className="mt-4 mb-4" id={formatId("Information Collected Automatically")}>
          <h4 className="text-lg font-semibold mb-2">
            c) Information Collected Automatically
          </h4>
          <p>
            When you visit Seobix.com, certain information is automatically
            collected to optimize website functionality and improve user
            experience. This includes  browser type, operating
            system, pages visited, time spent on the site, and other activity
            patterns.
          </p>
          <p>
            We use automated systems like Google Analytics, Moz analytics, and
            social media insights from platforms like Facebook, Instagram,
            LinkedIn, YouTube, and Meta to understand trends, track traffic, and
            enhance our offerings. This information is aggregated and anonymized
            wherever possible to ensure your privacy.
          </p>
        </section>

        <section className="mt-4 mb-4" id={formatId("Device and Usage Data")}>
          <h4 className="text-lg font-semibold mb-2">
            d) Device and Usage Data
          </h4>
          <p>
            Seobix.com collects device-specific data such as device type, unique
            device identifiers, operating system, and mobile network
            information. Usage data includes your interactions with our website,
            such as clicked links, downloads, and preferences.
          </p>
          <p>
            We utilize this data to personalize your experience, improve content
            delivery, optimize the website across devices, and detect security
            threats. Integration with third-party platforms like Google, Moz,
            and YouTube helps refine the quality of analytics and service
            delivery.
          </p>
        </section>

        <section className="mt-4 mb-4" id={formatId("Third-Party Widgets")}>
          <h4 className="text-lg font-semibold mb-2">e) Third-Party Widgets</h4>
          <p>
            Seobix.com integrates several third-party widgets to provide
            enhanced functionality and richer user experiences. These include:
          </p>
          <ul className="list-disc list-inside">
            <li>
              Google: For search functionality, analytics, and performance
              tracking.
            </li>
            <li>Moz: For SEO insights and domain analysis tools.</li>
            <li>YouTube: To embed videos and track viewer engagement.</li>
            <li>
              Instagram, Facebook, Meta, LinkedIn: To enable social sharing,
              login features, and content personalization.
            </li>
          </ul>
          <p>
            These third-party widgets may collect information such as IP
            addresses, device identifiers, user interactions, and social media
            profile data. We ensure that all third-party tools are compliant
            with data protection regulations, but their data collection
            practices are governed by their respective privacy policies.
            Seobix.com does not control the collection practices of these third
            parties, so we encourage users to review their policies to
            understand how your information is handled.
          </p>
        </section>

        <section className="mt-4 mb-4" id={formatId("Cookies and Similar Technologies")}>
          <h4 className="text-lg font-semibold mb-2">
            f) Cookies and Similar Technologies
          </h4>
          <p>
            Seobix.com uses cookies and similar tracking technologies to enhance
            your experience. Cookies help remember your preferences, analyze
            trends, provide targeted content, and improve site performance.
          </p>
          <p>
            We use tools from Google, Moz, YouTube, Facebook, Instagram,
            LinkedIn, and Meta that may set cookies on your device. These
            cookies can track website usage, user engagement with embedded
            content, and advertising effectiveness. You can manage or disable
            cookies through your browser settings, though some features of
            Seobix.com may not function correctly if cookies are disabled.
          </p>
        </section>

        {/* Remaining sections */}
        <section className="mt-4 mb-4" id={formatId("How We Use Your Personal Data")}>
          <h3 className="text-xl font-semibold mb-2">
            4. HOW WE USE YOUR PERSONAL DATA
          </h3>
          <ul className="list-disc list-inside">
            <li>Provide, maintain, and improve our services.</li>
            <li>Respond to inquiries, requests, or customer support issues.</li>
            <li>
              Deliver personalized content, recommendations, and marketing
              communications.
            </li>
            <li>
              Analyze usage patterns, trends, and performance metrics using
              analytics tools.
            </li>
            <li>
              Ensure website security, prevent fraud, and enforce our policies.
            </li>
            <li>Comply with legal obligations.</li>
          </ul>
        </section>

        <section className="mt-4 mb-4" id={formatId("How We Disclose Your Personal Data")}>
          <h3 className="text-xl font-semibold mb-2">
            5. HOW WE DISCLOSE YOUR PERSONAL DATA
          </h3>
          <p>
            Seobix.com may share your personal information with third-party
            service providers, social media platforms, law enforcement, and
            affiliates. We ensure that any third party receiving your data is
            bound by confidentiality and security obligations.
          </p>
        </section>

        <section className="mt-4 mb-4" id={formatId("Data Retention")}>
          <h3 className="text-xl font-semibold mb-2">6. DATA RETENTION</h3>
          <p>
            We retain personal data only as long as necessary to fulfill the
            purposes outlined in this policy or to comply with legal
            obligations. Usage data may be stored for analytical purposes,
            typically for a period of 12–24 months, depending on the type of
            data.
          </p>
        </section>

        <section className="mt-4 mb-4" id={formatId("How We Protect Your Personal Data")}>
          <h3 className="text-xl font-semibold mb-2">
            7. HOW WE PROTECT YOUR PERSONAL DATA
          </h3>
          <p>
            We implement appropriate technical and organizational measures to
            safeguard your personal data against unauthorized access, loss,
            alteration, or disclosure. These include encryption, secure servers,
             access controls, and regular audits.
          </p>
        </section>

        <section className="mt-4 mb-4" id={formatId("International Transfers of Personal Data")}>
          <h3 className="text-xl font-semibold mb-2">
            8. INTERNATIONAL TRANSFERS OF PERSONAL DATA
          </h3>
          <p>
            Some of your personal data may be processed or stored in countries
            outside your residence. Seobix.com ensures that international
            transfers comply with applicable data protection laws and include
            adequate safeguards.
          </p>
        </section>

      

        <section className="mt-4 mb-4" id={formatId("Privacy Rights and Choices")}>
          <h3 className="text-xl font-semibold mb-2">
            9. PRIVACY RIGHTS AND CHOICES
          </h3>
          <p>
            Depending on your jurisdiction, you may have rights such as
            accessing, correcting, deleting data, withdrawing consent, or opting
            out of marketing communications.
          </p>
        </section>

        <section className="mt-4 mb-4" id={formatId("Children")}>
          <h3 className="text-xl font-semibold mb-2">10. CHILDREN</h3>
          <p>
            Seobix.com does not knowingly collect personal data from individuals
            under 13 years of age. Parental consent is required for users under
            applicable age limits.
          </p>
        </section>

        <section className="mt-4 mb-4" id={formatId("Contact Information")}>
          <h3 className="text-xl font-semibold mb-2">
            11. CONTACT INFORMATION
          </h3>
          <p>
            For questions, concerns, or requests regarding this Privacy Policy
            or your personal data, please contact:
          </p>
          <p>
            <b>Seobix.com</b>
            <br />
            Email:{" "}
            <a href="mailto:support@Seobix.com" className="text-blue-600">
              support@Seobix.com
            </a>
          </p>
        </section>
      </div>
    </div>
  );
};

export default Privacy;
